import { call, put, takeEvery } from "redux-saga/effects"

import { GET_DOCUMENT_TYPES, ADD_NEW_DOCUMENT_TYPE, UPDATE_DOCUMENT_TYPE, DELETE_DOCUMENT_TYPE } from "./actionTypes";
import {
    getDocumentTypesSuccess,
    getDocumentTypesFail,
    addDocumentTypeSuccess,
    addDocumentTypeFail,
    updateDocumentTypeSuccess,
    updateDocumentTypeFail,
    deleteDocumentTypeSuccess,
    deleteDocumentTypeFail,
   
} from "./actions"

import {
    getDocumentTypes,
    addNewDocumentType,
    updateDocumentType,
    deleteDocumentType,
   
} from "helpers/document-types/document_types_backend_helper";
import { toast } from "react-toastify";

function* fetchDocumentTypes() {
    try {
        const response = yield call(getDocumentTypes)
        console.log("RESPONSE:", response);
        yield put(getDocumentTypesSuccess(response))
    } catch (error) {
        yield put(getDocumentTypesFail(error))
    }
}

function* onAddNewDocumentType({ payload }) {
    try {

        
        const response = yield call(addNewDocumentType, payload)

        console.log("RESPONSE:", response);
        yield put(addDocumentTypeSuccess(response.documentType))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addDocumentTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdateDocumentType({ payload: data }) {
    try {
        const response = yield call(updateDocumentType, data)
        yield put(updateDocumentTypeSuccess(response))
        toast.success("Branch  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateDocumentTypeFail(error))
        toast.error("Branch  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdateDocumentType({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateDocumentType, payload)
        yield put(updateDocumentTypeSuccess(response.documentType))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateDocumentTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteDocumentType({ payload}) {

    try {
        const response = yield call(deleteDocumentType, payload)
        yield put(deleteDocumentTypeSuccess(response.documentTypeId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteDocumentTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* documentTypeSaga() {
    yield takeEvery(GET_DOCUMENT_TYPES, fetchDocumentTypes)
    yield takeEvery(ADD_NEW_DOCUMENT_TYPE, onAddNewDocumentType)
    yield takeEvery(UPDATE_DOCUMENT_TYPE, onUpdateDocumentType)
    yield takeEvery(DELETE_DOCUMENT_TYPE, onDeleteDocumentType)
}

export default documentTypeSaga;